import { Component } from '@angular/core';
import { ProviderPriceService } from '../provider-price.service';

@Component({
  selector: 'app-upload-result',
  templateUrl: './upload-result.component.html',
  styleUrls: ['./upload-result.component.scss']
})
export class UploadResultComponent {
  constructor(private providerPriceService: ProviderPriceService) {}
}
